import { render } from "./ManualLocation.vue?vue&type=template&id=50105430"
import script from "./ManualLocation.vue?vue&type=script&lang=js"
export * from "./ManualLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__